<template>
  <div class="mt-8">
    <v-row dense>
      <template
        v-if="
          currentEvent.linkPrivacy == 'Private' ||
          currentEvent.linkPrivacy == 'Public'
        "
      >
        <v-col cols="12" class="d-flex">
          <div @click="tab = 0">
            <v-sheet
              :class="[
                'py-2 px-3 mr-2 cursor-pointer',
                tab == 0 ? 'white--text' : 'secondary--text',
              ]"
              :color="tab == 0 ? 'secondary' : 'bluishGrey'"
              key="tabAdmin"
              rounded="lg"
            >
              Admin
            </v-sheet>
          </div>
          <div @click="tab = 1">
            <v-sheet
              :class="[
                'py-2 px-3 cursor-pointer',
                tab == 1 ? 'white--text' : 'secondary--text',
              ]"
              :color="tab == 1 ? 'secondary' : 'bluishGrey'"
              key="tabAttendees"
              rounded="lg"
            >
              Attendees
            </v-sheet>
          </div>
        </v-col>
        <v-col cols="12" md="12" class="my-2">
          <div v-if="tab == 0">
            Invite people to join your EventConnect link as an admin
          </div>
          <div v-else>Invite people to join your EventConnect link</div>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn
            class="primary"
            depressed
            large
            width="150"
            @click="handleInviteClick"
            >Invite</v-btn
          >
        </v-col>
        <v-col md="4" sm="12">
          <v-text-field
            v-model="email"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            single-line
            hide-details
            placeholder="Search email"
            rounded
            dense
          ></v-text-field>
        </v-col>

        <!--Start: Invite admin dialog--->
        <v-dialog v-model="showInviteAdminDialog" width="450">
          <v-card>
            <v-card-title class="d-flex justify-space-between"
              ><div>Invite an admin</div>
              <v-btn fab text small @click="showInviteAdminDialog = false" right
                ><v-icon>close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-subtitle
              >A link to join your EventConnect link will be sent via
              email.</v-card-subtitle
            >
            <v-card-text>
              <v-form ref="inviteAdminForm" v-model="isInviteAdminFormValid">
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      outlined
                      placeholder="First name"
                      v-model="firstName"
                      :rules="requiredRules"
                      validate-on-blur
                  /></v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      outlined
                      placeholder="Last name"
                      v-model="lastName"
                      :rules="requiredRules"
                      validate-on-blur
                  /></v-col>
                  <v-col cols="12"
                    ><v-text-field
                      dense
                      outlined
                      placeholder="Email"
                      :rules="emailRules"
                      validate-on-blur
                      v-model="adminEmail" /></v-col
                  ><v-col cols="5" offset="7"
                    ><v-btn
                      :disabled="!isInviteAdminFormValid"
                      depressed
                      class="primary"
                      large
                      width="150"
                      @click="addAttendee(adminEmail, true)"
                      >Invite admin</v-btn
                    ></v-col
                  >
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--End: Invite admin dialog--->

        <!--Start: Invite attendee dialog--->
        <v-dialog v-model="showInviteAttendeeDialog" width="450">
          <v-card>
            <v-card-title class="d-flex justify-space-between"
              ><div v-if="addAttendeeTab == 0">Send invitation</div>
              <div v-else>
                <v-btn fab text small @click="addAttendeeTab = 0"
                  ><v-icon>mdi-chevron-left</v-icon></v-btn
                >
              </div>
              <v-btn
                fab
                text
                small
                @click="showInviteAttendeeDialog = false"
                right
                ><v-icon>close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-title class="pt-0" v-if="addAttendeeTab == 1">
              <div>Add emails</div></v-card-title
            >

            <v-card-subtitle class="pt-0">
              Paste emails from your spreadsheet or list, or add them
              individually.</v-card-subtitle
            >
            <v-card-text>
              <v-form
                ref="inviteAttendeeFormRef"
                @keydown.enter="$event.preventDefault()"
              >
                <v-tabs-items v-model="addAttendeeTab">
                  <v-tab-item v-if="currentEvent.linkPrivacy == 'Private'">
                    <v-row align="start" dense>
                      <v-col cols="12">
                        <v-checkbox
                          class="mt-0"
                          v-model="inviteToAllSubEvents"
                          @change="handleInviteToAllSubEventsChange"
                          label="Invitation to all sub-events"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="12" v-if="allSubEvents.length > 0">
                        <div class="d-flex flex-wrap">
                          <v-chip
                            @click="handleSubEventClick(subEvent)"
                            class="mr-3 mb-3"
                            :color="
                              selectedSubEvents.includes(subEvent.id)
                                ? 'secondary'
                                : ''
                            "
                            label
                            v-for="(subEvent, index) in allSubEvents"
                            :key="`subEvent${index}`"
                            >{{ subEvent.name }}</v-chip
                          >
                        </div>
                      </v-col>
                      <v-col class="mt-10 text-right">
                        <v-btn
                          :disabled="selectedSubEvents.length == 0"
                          class="primary"
                          @click="addAttendeeTab = 1"
                          depressed
                          width="100"
                          large
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col cols="12">
                        <BulkEmail
                          ref="emailInput"
                          v-model="attendeeEmail"
                          @clear="attendeeEmail = ''"
                          @email-added="handleAttendeeEmailsAdded"
                          @disable-add="handleDisableAdd"
                          :isInvitingAttendee="true"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--End: Invite attendee dialog--->
      </template>

      <template v-else>
        <v-col cols="12" md="12">
          <div class="d-flex justify-start">
            <v-checkbox
              label="I want to join the EventConnect link"
              class="pr-4"
              v-model="addHostToEvent"
              @change="handleChange"
            ></v-checkbox>

            <v-tooltip bottom max-width="250">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" class="ml-2" size="22">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>
                Add yourself to this EventConnect link so that other people can
                connect with you.
              </span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-bold">
            Invite people to join your EventConnect link
          </div>
          <p>
            An invitation email will be sent once you hit the Invite button.
          </p>
        </v-col>

        <v-col cols="12">
          <v-form
            ref="emailForm"
            @submit.prevent="handleAdd"
            :disabled="businessProfile.plan != 'evolve'"
          >
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <!-- <v-text-field
                dense
                outlined
                placeholder="Type email..."
                ref="emailInput"
                v-model="email"
                :rules="emailRules"
              /> -->
                <BulkEmail
                  ref="emailInput"
                  v-model="email"
                  @clear="email = ''"
                  @email-added="handleAddedEmails"
                  @disable-add="handleDisableAdd"
                  :showBulkEmailDialog="showBulkEmailDialog"
                  @close-bulk-email-dialog="showBulkEmailDialog = false"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-btn
                  color="primary lighten--3"
                  depressed
                  type="button"
                  class="text-body-1 py-5 ml-3 primary lighten--3"
                  @click="handleAdd"
                  :disabled="isAddDisabled"
                  >Invite</v-btn
                >
                <!-- @keyup.enter="handleAdd" -->
              </v-col>
              <v-col cols="4" class="text-right">
                <v-btn text @click="showBulkEmailDialog = true"
                  ><v-icon small class="mr-2">mdi-email-multiple</v-icon>Send
                  invitations in bulk</v-btn
                ></v-col
              >
              <!-- <v-col cols="12" md="12">
                <v-tooltip bottom max-width="250">
                  <template v-slot:activator="{ on, attrs }">                 
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="ml-4 mt-5 primary--text text-decoration-underline"
                    >
                      Bulk Upload
                    </span>
                  </template>
                  <span>
                    You can send multiple invitations by pasting them from
                    either your spreadsheet or your list.</span
                  >
                </v-tooltip>
              </v-col> -->
            </v-row>
          </v-form>
        </v-col>
      </template>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="12">
        <v-data-table
          :headers="headers"
          :items="invitees"
          hide-default-footer
          class="mt-0 px-0"
          :search="email"
          disable-pagination
        >
          <template slot="no-data">
            <div>You don't have any attendees</div>
          </template>
          <template v-slot:item.email="{ item }">
            <div class="px-0">
              {{ item.email }}
            </div>
          </template>
          <template v-slot:item.ticketType="{ item }">
            <div class="px-0">
              <v-chip v-if="item.ticketType" dark :color="generalDelegateTicketClassNames.includes(item.ticketType) ? 'green' : 'grey-100'" label>{{ item.ticketType }}</v-chip>
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="px-0">
              {{ item.firstName + " " + item.lastName }}
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <div class="px-0">
              {{ getInviteeStatus(item) }}
            </div>
          </template>
          <template v-slot:item.invitedSubEvents="{ item }">
            {{ getInvitedSubEvents(item) }}
          </template>
          <template v-slot:item.sent="{ item }">
            <div v-if="bulkEmailList.includes(item.email)">Sending...</div>
            <timeago
              v-else-if="item.invitedAt != null"
              :datetime="Date.parse(item.invitedAt)"
              :auto-update="60"
            ></timeago>
          </template>
          <template v-slot:item.action="{ item }">
            <v-menu
              transition="slide-y-transition"
              bottom
              left
              offset-y
              v-if="isEditMode"
              class="white"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list class="white" nav>
                <v-list-item 
                @click="handleResendInvitation(item)"
                v-if="!item.eventId"
                >
                  <v-list-item-title>Resend invitation</v-list-item-title>
                </v-list-item>
                <v-list-item 
                v-if="item.eventId"
                >
                  <v-list-item-icon>
                    <v-icon>info</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Only actionable through the Script</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="showConfirmation(item)"
                  v-if="getInviteeStatus(item) == 'Invited'"
                >
                  <v-list-item-title>Remove invitee</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <template v-else>
              <v-icon
                @click="showConfirmation(item)"
                color="primary primary--text"
                small
                >close</v-icon
              >
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" left :timeout="snackbarTimeout">
      <v-list-item class="px-0" dense>
        <template v-if="progressValue < 100">
          <v-progress-circular
            class="mr-4"
            :width="5"
            :value="progressValue"
            color="primary"
          >
          </v-progress-circular>
        </template>

        <v-slide-y-transition v-else>
          <div class="text-h6 mr-4">🎉</div>
        </v-slide-y-transition>

        <v-list-item-content>
          <v-list-item-title style="white-space: normal"
            >Sending Invitations</v-list-item-title
          >
          <v-list-item-subtitle
            >Sent {{ bulkInviteProgress }} of
            {{ addedEmails.length }} emails</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar = false"
          top
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <ConfirmationDialog
      :show="showConfirmationDialog"
      title="Remove invitation?"
      :content="content"
      @click="removeInvitee"
      @closeDialog="showConfirmationDialog = false"
      buttonText="Remove"
    />

    <LoadingDialog :show="showLoadingDialog" :title="loadingDialogTitle" />
  </div>
</template>

<script>

import Attendee from "@/models/Attendee";
import { mapGetters, mapActions } from "vuex";
let uuid = require("uuid");
import ConfirmationDialog from "@/components/ConfirmationDialog";
import BulkEmail from "@/components/inputs/BulkEmail";
import LoadingDialog from "@/components/LoadingDialog";
import { getAuth } from "firebase/auth";
import {getQueryEventCollection, queryByCollectionName} from "@/shared/firebase_utils";
import {onSnapshot, where} from "firebase/firestore";

export default {
  props: {
    isEditMode: { type: Boolean, default: false },
  },
  components: {
    ConfirmationDialog,
    BulkEmail,
    LoadingDialog,
  },
  async created() {
    this.usersEmail = getAuth().currentUser.email;

    if (
      !this.currentEvent.invitees.some(
        (invitee) => invitee.email == this.usersEmail
      ) &&
      this.addHostToEvent
    ) {
      this.addAttendee(this.usersEmail, false);
      // let attendee = new Attendee({
      //   email: this.usersEmail,
      //   attendeeId: uuid.v4(),
      // });
      // this.currentEvent.attendees.push(attendee);
      this.set

    }

    //Set addHostToEvent to true if host has been added to event
    if (
      this.currentEvent.invitees.some(
        (invitee) => invitee.email == this.usersEmail
      )
    )
      this.addHostToEvent = true;

    //For private event attendees, get sub-event names
    if (this.currentEvent.linkPrivacy == "Private") {
      let allSubEventRef = await getQueryEventCollection(
          where("businessProfileId", "==", this.userProfile.businessProfileId),
          where("parentMultiConnectEventId", "==", this.currentEvent.id),
          where("parentSubEventId", "==", ""),
      );

      this.allSubEvents = allSubEventRef.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    }

    this.getEventAttendeesFromCollection();
    
  },
  computed: {
    ...mapGetters(["currentEvent", "userProfile", "businessProfile"]),
    // isAddDisabled() {
    //   let isDisabled = true;
    //   if (this.addedEmails != "") {
    //     isDisabled = !this.$refs.emailForm.validate();
    //     //this.$refs.emailForm.resetValidation();
    //   }

    //   return isDisabled;
    // },
    progressValue() {
      return (this.bulkInviteProgress * 100) / this.addedEmails.length;
    },
    invitees() {
      if (this.currentEvent.linkPrivacy == "Public") {
        this.headers = [
          {
            text: "Email",
            value: "email",
            align: "start",
          },
          {
            text: "Ticket Type",
            value: "ticketType",
            align: "start",
          },
          {
            text: "Status",
            value: "status",
            align: "start",
          },
          {
            text: "Sent",
            value: "sent",
            align: "start",
          },
          { text: "Actions", value: "action", align: "center" },
        ];
        return [...this.currentEvent.invitees, ...this.inviteesFromCollection];
      } else if (this.currentEvent.linkPrivacy == "Private" && this.tab == 0) {
        let invitees = this.currentEvent.invitees.filter(
          (invitee) => invitee.isAdmin
        );
        this.headers = [
          {
            text: "Name",
            value: "name",
            align: "start",
          },
          {
            text: "Email",
            value: "email",
            align: "start",
          },
          {
            text: "Status",
            value: "status",
            align: "start",
          },
          {
            text: "Sent",
            value: "sent",
            align: "start",
          },
          { text: "Actions", value: "action", align: "center" },
        ];
        return invitees;
      } else {
        let invitees = this.currentEvent.invitees.filter(
          (invitee) =>
            !invitee.isAdmin && invitee.associatedSpeakerSessions.length == 0
        );
        this.headers = [
          {
            text: "Email",
            value: "email",
            align: "start",
          },
          {
            text: "Invitation To",
            value: "invitedSubEvents",
            align: "start",
          },
          {
            text: "Status",
            value: "status",
            align: "start",
          },
          {
            text: "Sent",
            value: "sent",
            align: "start",
          },
          { text: "Actions", value: "action", align: "center" },
        ];
        return invitees;
      }
    },
  },
  data() {
    return {
      headers: [],
      email: "",
      usersEmail: "",
      addHostToEvent: false,
      emailRules: [
        (v) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Please enter a valid email",
      ],
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: -1,
      content: "",
      showConfirmationDialog: false,
      removeInviteeIndex: -1,
      addedEmails: [],
      isAddDisabled: true,
      bulkInviteProgress: 0,
      bulkEmailList: [],
      showSingleSnackbar: false,
      showBulkEmailDialog: false,
      tab: 0,
      showInviteAdminDialog: false,
      firstName: "",
      lastName: "",
      showInviteAttendeeDialog: "",
      allSubEvents: [],
      selectedSubEvents: [],
      addAttendeeTab: 0,
      inviteToAllSubEvents: false,
      showLoadingDialog: false,
      loadingDialogTitle: "",
      adminEmail: "",
      attendeeEmail: "",
      isInviteAdminFormValid: false,
      requiredRules: [(v) => !!v || "This field is required"],
      inviteesFromCollection: [],
      generalDelegateTicketClassNames:  [
        "Standard Delegate",
        "International Delegate",
        "Student Delegate",
        "Startup Delegate",
        "Producer Delegate",
        "Early bird - Standard Delegate",
        "Early bird - Producer Delegate",
        "Standard Delegate (Groups 10-19)",
        "Producer Delegate (Groups 10-19)",
        "Media delegate",
        "Early bird - Producer Delegate (Groups 10-19)",
        "Early bird - Standard Delegate (Groups 10-19)",
      ]
    };
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    getEventAttendeesFromCollection() {

      //Set a snapshot listner to get the invitees from the "event_invitations" collection and set it to the inviteesFromCollection
      onSnapshot(
            queryByCollectionName("event_invitations", where("eventId", "==", this.currentEvent.id)),
            (snapshot) => {
          this.inviteesFromCollection = snapshot.docs.map((doc) => {
            //Convert the doc data to an Attendee object
            return new Attendee.fromObject(doc.data());
          });
        });
    },
    async handleAdd() {
      // this.$refs.emailInput.blur();
      this.showSingleSnackbar = true;
      this.addAttendee(this.email, false);
      this.$refs.emailInput.resetForm();
      this.email = "";
    },
    handleChange() {
      if (this.addHostToEvent) {
        this.addAttendee(this.usersEmail, false);
      } else {
        let index = this.currentEvent.invitees
          .map((invitee) => invitee.email)
          .indexOf(this.usersEmail);

        this.currentEvent.invitees.splice(index, 1);

        //Save the event
        this.currentEvent.save();
      }
    },
    handleNext() {
      this.currentEvent.save();
    },

    showConfirmation(invitee) {
      this.removeInviteeIndex = this.currentEvent.invitees.indexOf(invitee);
      this.content = `An invitation email has been sent to ${invitee.email} This attendee will not be able to join the EventConnect link anymore`;
      this.showConfirmationDialog = true;
    },

    removeInvitee() {
      this.currentEvent.invitees.splice(this.removeInviteeIndex, 1);
      this.showConfirmationDialog = false;
      this.showSnackbar({ show: true, text: "Removed successfully!" });

      this.currentEvent.save();
    },
    async addAttendee(email, isAdmin) {
      if (
        this.currentEvent.invitees.some((invitee) => invitee.email == email)
      ) {
        this.showSnackbar({
          show: true,
          text: "Attendee has been invited already!",
        });
      } else {
        let invitee;

        if (isAdmin) {
          //For admin invitees of pvt event
          invitee = new Attendee({
            email: email,
            attendeeId: uuid.v4(),
            invitedAt: new Date(),
            accessToken: uuid.v4(),
            firstName: this.firstName,
            lastName: this.lastName,
            isAdmin: true,
          });
          //Hide the invite admin dialog
          this.showInviteAdminDialog = false;
          //Clear form fields
          this.$refs.inviteAdminForm.reset();
          //Show loading dialog
          this.loadingDialogTitle = "Saving admin...";
          this.showLoadingDialog = true;
        } else if (this.currentEvent.linkPrivacy == "Private" && !isAdmin) {
          //For attendees invitees of pvt event
          invitee = new Attendee({
            email: email,
            attendeeId: uuid.v4(),
            invitedAt: new Date(),
            accessToken: uuid.v4(),
            associatedSubEvents: this.selectedSubEvents,
          });
        } else {
          //Invitees of public events
          invitee = new Attendee({
            email: email,
            attendeeId: uuid.v4(),
            invitedAt: new Date(),
            accessToken: uuid.v4(),
          });
        }

        if (this.currentEvent.linkPrivacy == "Private")
          await invitee.generatePrivateLink(
            this.currentEvent.id,
            this.currentEvent.name
          );

        this.currentEvent.invitees.unshift(invitee);

        //Save
        this.currentEvent.save();

        
        let isSuccess = await this.sendInvitationEmail(invitee);

        if (this.showSingleSnackbar) {
          // Email sent successfully!
          let text = isSuccess
            ? "Added successfully!"
            : "Error, please try again";
          // let text = "Added successfully!";

          this.showSnackbar({ show: true, text: text });
          this.showSingleSnackbar = false;
        }

        if (isAdmin) {
          this.showLoadingDialog = false;
        }
      }
    },

    async sendInvitationEmail(invitee) {
      let invitationLink = "";
      if (this.currentEvent.linkPrivacy == "Public")
        invitationLink = this.currentEvent.dynamicLink;
      else invitationLink = invitee.dynamicLink;
      let result = await invitee.sendInvitation(
        this.currentEvent.linkPrivacy,
        invitationLink,
        this.currentEvent.name,
        this.userProfile.firstName,
        this.userProfile.lastName,
        this.currentEvent.hostName
      );

      if (result.data.success) {
        //Start: UNCOMMENT LATER
        // this.$refs.emailForm.resetValidation();
        //End:  UNCOMMENT LATER
        this.bulkInviteProgress += 1;
      }

      return result.data.success;
    },
    async handleAddedEmails(emails) {
      this.addedEmails = emails;
      this.bulkEmailList = emails;
      this.snackbarTimeout = -1;
      this.bulkInviteProgress = 0;
      // this.snackbar = true;

      await emails.reduce(async (promise, email) => {
        // This line will wait for the last async function to finish.
        // The first iteration uses an already resolved Promise
        // so, it will immediately continue.
        await promise;
        await this.addAttendee(email, false);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        this.bulkEmailList = this.bulkEmailList.filter(
          (addedEmail) => addedEmail != email
        );
      }, Promise.resolve());
      this.snackbarTimeout = 5000;

      //Start: Clear selected sub-events for attendees
      this.selectedSubEvents = [];
      this.inviteToAllSubEvents = false;
    },
    handleSearchEmails(emails) {
      this.addedEmails = emails.toString();
    },
    handleDisableAdd(isAddDisabled) {
      this.isAddDisabled = isAddDisabled;
    },

    handleResendInvitation(email) {
      this.showSingleSnackbar = true;
      let isSuccess = this.sendInvitationEmail(email);

      if (this.showSingleSnackbar) {
        let text = isSuccess
          ? "Email sent successsully!"
          : "Error sending email";

        this.showSnackbar({ show: true, text: text });
        this.showSingleSnackbar = false;
      }
    },
    handleInviteClick() {
      if (this.tab == 0) {
        this.showInviteAdminDialog = true;
        this.$nextTick(() => this.$refs.inviteAdminForm.reset());
      } else {
        this.showInviteAttendeeDialog = true;
        this.$nextTick(() => {
          this.$refs.inviteAttendeeFormRef.reset();
          this.attendeeEmail = "";
          this.selectedSubEvents = [];
          this.addAttendeeTab = 0;
        });
      }
    },
    handleSubEventClick(subEvent) {
      let index = this.selectedSubEvents.indexOf(subEvent.id);
      if (index == -1) this.selectedSubEvents.push(subEvent.id);
      else this.selectedSubEvents.splice(index, 1);

      //Set value of checkbox to add to all sub events if needed
      let allSubEventIds = this.allSubEvents.map((subEvent) => subEvent.id);

      if (allSubEventIds.every((id) => this.selectedSubEvents.includes(id)))
        this.inviteToAllSubEvents = true;
      else this.inviteToAllSubEvents = false;
    },
    handleInviteToAllSubEventsChange() {
      if (this.inviteToAllSubEvents) {
        this.selectedSubEvents = this.allSubEvents.map(
          (subEvent) => subEvent.id
        );
      } else {
        this.selectedSubEvents = [];
      }
    },

    handleAttendeeEmailsAdded(emails) {
      this.handleAddedEmails(emails);
      this.showInviteAttendeeDialog = false;
      // this.$refs.inviteAttendeeFormRef.reset();
      this.attendeeEmail = "";
      this.addAttendeeTab = 0;
    },
    getInvitedSubEvents(invitee) {
      let invitedSubEvents = this.allSubEvents.filter((subEvent) =>
        invitee.associatedSubEvents.includes(subEvent.id)
      );
      invitedSubEvents = invitedSubEvents.map((subEvent) => subEvent.name);
      let invitedSubEventNames = invitedSubEvents.join(", ");

      return invitedSubEventNames;
    },
    getInviteeStatus(invitee) {
      if (invitee.status)
        return invitee.status;
      let hasJoined = this.currentEvent.attendees.some(
        (attendee) => attendee.accessToken == invitee.accessToken
      );
      if (hasJoined) return "Joined";
      else return "Invited";
    },
  },
};
</script>

<style></style>
